import paths from "routes/paths";

import AbstractApiActioner from "services/cores/abstractApiActioner";
import DisplaysApi from "./api";
import DisplaysActionTypes from "./types";
import DisplaysUtils from "./utils";

class DisplaysActioner extends AbstractApiActioner {
  setAutoRefresh(autoRefresh) {
    return {
      type: DisplaysActionTypes.SET_AUTO_REFRESH,
      autoRefresh,
    };
  }

  setSelectedLayers(layers) {
    return {
      type: DisplaysActionTypes.SET_SELECTED_LAYERS,
      layers,
    };
  }

  updateStandBy(id, standBy) {
    return DisplaysApi.updateStandBy(id, standBy);
  }

  updateRule(id, rule) {
    return DisplaysApi.updateRule(id, rule);
  }

  updateEmergencyRule(id, isActive) {
    return DisplaysApi.updateEmergencyRule(id, isActive);
  }
}

export default new DisplaysActioner(
  "Displays",
  DisplaysActionTypes,
  DisplaysApi,
  DisplaysUtils,
  {
    paths: {
      default: paths.api.iot.displays.general,
    },
  }
);
